import React from 'react';
import { Box, Button } from '@mui/material';
import { QuizStyles } from '../styles/QuizStyles';

interface FinalExamCompletionButtonProps {
  isVisible: boolean;
  onComplete: () => void;
}

const FinalExamCompletionButton: React.FC<FinalExamCompletionButtonProps> = ({
  isVisible,
  onComplete,
}) => {
  if (!isVisible) return null;

  return (
    <Box sx={QuizStyles.completeQuizButtonContainer}>
      <Button variant="contained" onClick={onComplete}>
        Complete Exam
      </Button>
    </Box>
  );
};

export default FinalExamCompletionButton;
